// İSG uzmanı portalı — `Giriş` panelinin `QR` alt-sekmesi: oturum başlamadıysa giriş kartı,
// başladıysa `GateStage`. Yoklama/dönme hook'u (`useGateCode`) `SecuritySiteSession`'da YAŞAR
// (tasarım spec'i §8.9 — sekme değişse bile durmaz); bu bileşen yalnız SUNAR.
//
// Kendi kart kabuğunu TAŞIMAZ (S32b) — `EntryPanel.tsx`'in panel gövdesine oturur.

import { Button } from '@isgportal/shared';
import { QrCode, ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { UseGateCodeResult } from '../../lib/useGateCode';
import { GateStage } from './GateStage';

export interface GateCodeTabProps {
  sessionOpen: boolean;
  gate: UseGateCodeResult;
  onStart: () => void;
  onStop: () => void;
  /** `security:gate-result` bilinen (dayEntries'ten erken) 403'ü — sekme HİÇ gizlenmez/devre
   *  dışı bırakılmaz (S32b §5 kural 2), oturum başlamamış olsa BİLE açıklama gösterilir. */
  forbidden: boolean;
  /** S32d owner talebi (`GateStage.tsx` dosya başı notu) — sahnede bir karar varken QR gizlenir. */
  verdictPending: boolean;
}

export function GateCodeTab({
  sessionOpen,
  gate,
  onStart,
  onStop,
  forbidden,
  verdictPending,
}: GateCodeTabProps) {
  const { t } = useTranslation();

  if (forbidden && !sessionOpen) {
    return (
      <div className="flex min-h-[16rem] flex-col items-center justify-center gap-4 p-8 text-center">
        <ShieldAlert className="h-10 w-10 text-muted" aria-hidden="true" />
        <div className="flex flex-col gap-1.5">
          <h3 className="text-lg font-semibold text-fg">{t('security.gate.forbidden.title')}</h3>
          <p className="max-w-sm text-sm text-muted">{t('security.gate.forbidden.body')}</p>
        </div>
      </div>
    );
  }

  if (!sessionOpen) {
    return (
      <div className="flex min-h-[16rem] flex-col items-center justify-center gap-4 p-8 text-center">
        <QrCode className="h-12 w-12 text-primary" aria-hidden="true" />
        <div className="flex flex-col gap-1.5">
          <h3 className="text-lg font-semibold text-fg">{t('security.gate.intro.title')}</h3>
          <p className="max-w-sm text-sm text-muted">{t('security.gate.intro.body')}</p>
        </div>
        <Button size="lg" onClick={onStart}>
          {t('security.gate.show')}
        </Button>
      </div>
    );
  }

  return <GateStage gate={gate} onStop={onStop} verdictPending={verdictPending} />;
}
